(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rival-trs-mobile"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-trs-stage]');
  if (!link) return;
  const radio = Array.from(document.querySelectorAll('.product-form__input input[type="radio"]')).find(input => input.value === link.dataset.trsStage);
  if (radio) {
    const label = Array.from(document.querySelectorAll('.product-form__input label')).find(item => item.htmlFor === radio.id);
    if (label) label.click();
  }
});

function trsSelectAppTab(tab, focus = false) {
  const demo = tab.closest('[data-trs-demo]');
  if (!demo) return;
  demo.querySelectorAll('[role="tab"]').forEach(item => {const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;});
  demo.querySelectorAll('[role="tabpanel"]').forEach(panel => {panel.hidden = panel.id !== tab.getAttribute('aria-controls');});
  if (focus) tab.focus();
}
document.addEventListener('click', event => {const tab = event.target.closest('[data-trs-demo] [role="tab"]'); if (tab) trsSelectAppTab(tab);});
document.addEventListener('keydown', event => {
  const tab = event.target.closest('[data-trs-demo] [role="tab"]');
  if (!tab || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
  event.preventDefault();
  const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
  let index = tabs.indexOf(tab);
  if (event.key === 'Home') index = 0;
  else if (event.key === 'End') index = tabs.length - 1;
  else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  trsSelectAppTab(tabs[index], true);
});

  } catch(e) { console.error(e); }
})();
})();
